var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav", class: _vm.smallMargin ? "mb-4" : "mb-8" },
    [
      _c(
        "ul",
        {
          ref: "navigation",
          staticClass: "flex-level m-0",
          attrs: { id: "cart-navigation" }
        },
        [
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  ref: "plan-link",
                  staticClass: "semibold white-bkg b-0 p-0 pb-2 fs-3 cpointer",
                  attrs: {
                    activeClass: "primary-50",
                    tag: "button",
                    to: {
                      name:
                        _vm.context === "client"
                          ? "sam.v4.client.form.plan"
                          : "sam.v4.client." + _vm.context + ".form.plan",
                      params: { id: _vm.$route.params.id }
                    },
                    append: ""
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Choisir un plan")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "ml-4" },
            [
              _c(
                "router-link",
                {
                  ref: "config-link",
                  staticClass: "semibold white-bkg b-0 p-0 pb-2 cpointer fs-3",
                  attrs: {
                    activeClass: "primary-50",
                    tag: "button",
                    to: {
                      name:
                        _vm.context === "client"
                          ? "sam.v4.client.form.configuration"
                          : "sam.v4.client." +
                            _vm.context +
                            ".form.configuration",
                      params: { id: _vm.$route.params.id }
                    },
                    append: ""
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Configuration")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSourceSale &&
          !_vm.isLatestPricingVersion &&
          _vm.context === "renew"
            ? _c(
                "li",
                { staticClass: "ml-4" },
                [
                  _c(
                    "router-link",
                    {
                      ref: "licence-link",
                      staticClass:
                        "semibold white-bkg b-0 p-0 pb-2 cpointer fs-3",
                      attrs: {
                        activeClass: "primary-50",
                        tag: "button",
                        to: {
                          name: "sam.v4.client.renew.form.licences",
                          params: { id: _vm.$route.params.id }
                        },
                        append: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$l10n.__("Gestion des licences")) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "ml-4" },
            [
              _c(
                "router-link",
                {
                  ref: "pay-link",
                  staticClass: "semibold white-bkg b-0 p-0 pb-2 fs-3",
                  class: {
                    cpointer: _vm.canGoToPayment,
                    cnotallowed: !_vm.canGoToPayment
                  },
                  attrs: {
                    activeClass: "primary-50",
                    disabled: !_vm.canGoToPayment,
                    tag: "button",
                    to: {
                      name:
                        _vm.context === "client"
                          ? "sam.v4.client.form.payment"
                          : "sam.v4.client." + _vm.context + ".form.payment",
                      params: { id: _vm.$route.params.id }
                    },
                    append: ""
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Paiement")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "selected-underline primary-50-bkg",
        style: {
          left: _vm.underlineOffset + "px",
          width: _vm.underlineWidth + "px"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }